import PropTypes from 'prop-types';

import { palette, paletteTypes } from './palette';

const themeTypes = {};

paletteTypes.forEach((type) => {
  themeTypes[type] = PropTypes.objectOf(PropTypes.string);
});

export const propTypes = {
  theme: PropTypes.shape(themeTypes),
};

export const defaultProps = {
  theme: palette,
};



// WEBPACK FOOTER //
// ./src/styles/types.js